var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"variant":"link","right":""}},[_c('div',{staticClass:"text-success"},[_c('feather-icon',{attrs:{"icon":"PhoneIcon","size":"15"}}),_c('span',{staticClass:"ml-50 text-body"},[_vm._v("01624-595959")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }